<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <!-- <router-link to="/manage">SKU管理</router-link>
      <span class="arrow"><i class="iconfont icon-arrow"></i></span>
      <span>商品管理</span> -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <p class="flex-rowl">
            <i class="iconfont icon-danxuanyixuan"></i> 全选
          </p>
          <router-link to="/commondityIndex/addCommondity"
            ><p class="flex-rowl">
              <i class="iconfont icon-xinzeng"></i> 新增
            </p></router-link
          >
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="关键词查找"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc">
            <span>快速数据</span>
            <i class="iconfont icon-zhexiantu"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div class="check">
                <i class="iconfont icon-danxuanyixuan"></i>
              </div>
              <div class="content_wrap flex-between">
                <div class="pic_box">
                  <el-image :src="item.img" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div>
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <h1>商品名称：</h1>
                    <p>
                      <span>{{ item.commodityname }}</span>
                    </p>
                    <p>
                      <span>{{ item.commodityname_e }}</span>
                    </p>
                    <p>
                      <span>{{ item.commodityname_y }}</span>
                    </p>
                    <p>
                      <span>{{ item.commodityname_m }}</span>
                    </p>
                    <p>
                      <span>{{ item.commodityname_t }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      商品ID：<span>{{ item.id }}</span>
                    </p>
                    <p>
                      企业名称（ID）：<span>{{
                        item.qyname ? item.qyname : item.qy_accountid
                      }}</span>
                    </p>
                    <p>
                      SKU采购编码：<span>{{ item.sku }}</span>
                    </p>
                    <p>
                      品牌标签：<span>{{ item.brandname }}</span>
                    </p>
                    <p>
                      ISBN编码：<span>{{ item.ISBN }}</span>
                    </p>
                    <p>
                      是否精品推荐：<span>{{ item.isintro }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      是否上架：<span>{{ item.commoditystate }}</span>
                    </p>
                    <p>
                      销售状态：<span>{{ item.salestate }}</span>
                    </p>
                    <p>
                      限购状态：<span v-if="item.islimit">{{
                        item.islimit == "不限购"
                          ? item.islimit
                          : "每人限购/" + item.limitnum + "件"
                      }}</span>
                    </p>
                    <p>
                      所属分类：<span v-if="item.labelname"
                        >{{ item.labelname }}、</span
                      >
                      <span v-if="item.labelname2"
                        >{{ item.labelname2 }}、</span
                      >
                      <span v-if="item.labelname3">{{ item.labelname3 }}</span>
                    </p>
                    <p>
                      商品类型：<span>{{ item.comtype }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      结算类型：<span>{{ item.paytype }}</span>
                    </p>
                    <p>
                      基础零售价：<span v-if="item.price"
                        >¥ {{ item.price }}</span
                      >
                    </p>
                    <p>
                      普通用户积分价：<span>{{ item.userscore1 }}</span>
                    </p>
                    <p>
                      商务合作用户积分价：<span>{{ item.userscore2 }}</span>
                    </p>
                    <p>
                      企业积分价：<span>{{ item.userscore3 }}</span>
                    </p>
                    <p>
                      批发售价：
                      <span v-if="item.groupprice">¥ {{ item.groupprice }}</span
                      ><span>/每组</span>
                    </p>
                  </div>
                  <div class="block">
                    <!-- <p>
                      批发商品组规格： <span>{{ item.groupnum }}</span
                      ><span>件/每组</span>
                    </p> -->
                    <p>
                      单款混选起批数量： <span>{{ item.startnum1 }}</span
                      ><span>件/起批</span>
                    </p>
                    <!-- <p>
                      混样多选起批数量： <span>{{ item.startnum2 }}</span
                      ><span>组</span>
                    </p> -->
                  </div>
                </div>
                <div class="operation_box flex-colt">
                  <router-link
                    :to="'/commondityIndex/cManageEdit/cBaseinfo/' + item.id"
                    >基础信息设置</router-link
                  >
                  <router-link
                    :to="'/commondityIndex/cManageEdit/cImages/' + item.id"
                    >产品图片设置</router-link
                  >
                  <router-link
                    :to="'/commondityIndex/cManageEdit/cSalesParams/' + item.id"
                    >销售参数设置</router-link
                  >
                  <router-link
                    :to="'/commondityIndex/cManageEdit/cAttrLabel/' + item.id"
                    >属性标签&规格变量设置</router-link
                  >
                  <router-link
                    :to="'/commondityIndex/cManageEdit/cDetail/' + item.id"
                    >商品详情设置</router-link
                  >
                  <router-link
                    :to="'/commondityIndex/cManageEdit/cLabel/' + item.id"
                    >商品标签设置</router-link
                  >
                  <router-link
                    :to="'/commondityIndex/cManageEdit/cOthers/' + item.id"
                    >其他设置</router-link
                  >
                </div>
              </div>
            </div>
            <div class="shop_more"></div>
          </div>
        </template>
        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>

<script>
import { getMenuAuthTwo, getCommondity } from "../../api/api";
export default {
  name: "cManageIndex",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      loading: false,
      listTotal: 0,
      dataList: [],
      params: {
        Page: 1,
        PageSize: 10,
        typeid: "",
        keyword: "",
        istop: "",
        comtype: "",
        scorewide: "",
        isintro: "", // 推荐 1 非推荐的 0， 留空则显示全部
        labels: "", // 可以输入特定标签，比如 爆款 新品
        ordertype: "1", // 1 综合排序 2价格升序  3 价格降序 4积分升序  5积分降序
        brandid: "",
        commoditystate: 2, // 1 上架 0 下架 2 全部 留空为上架
        qyid: 0,
      },
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.params.qyid = userInfo.qy.id;
    } else {
      this.params.qyid = 0;
    }
    this.roleId = userInfo.qy.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
    this.initData();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    handleCurrentChange(e) {
      this.params.Page = e;
      // this.dataList = [];
      this.initData();
    },
    handleSearch() {
      this.params.Page = 1;
      this.initData();
    },
    initData() {
      let { params } = this;
      this.loading = true;
      getCommondity(params).then((res) => {
        res.list.forEach((v) => {
          if (v.createdate && v.createdate.indexOf("T") != 0) {
            let createdateSplit = v.createdate.split("T");
            v.createdateNew = createdateSplit[0] + " " + createdateSplit[1];
          }
        });
        this.listTotal = res.total;
        // this.dataList = res.list.concat(...this.dataList);
        this.dataList = res.list;
        this.loading = false;
        // this.dataList = this.dataList.concat(...res.list);
      });
    },

    // 触发滑动事件
    handleScroll(e) {
      let el = e.target;
      // let { listTotal, dataList } = this;
      //判断是否到达div容器底部
      if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
        // if (listTotal > dataList.length) {
        //   this.params.Page += 1;
        //   this.initData();
        // }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .main_container {
    .select_add {
      p {
        &:last-child {
          margin-left: 49px;
        }
      }
    }
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
  }
}
</style>